var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"Loading"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"secondary"}}),_c('p',{attrs:{"align":"center"}},[_c('small',{domProps:{"textContent":_vm._s('Cargando...espere un momento')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }